<template>
  <v-app color="primary" fixed :dark="$vuetify.dark" app>
    <Menus/>
    <Toolbar :title="title"/>
    <v-content>
      <v-fade-transition mode="out-in">
        <div>
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive && resufreshed"></router-view>
          </keep-alive>
          <router-view v-if="!$route.meta.keepAlive && resufreshed"></router-view>
        </div>
      </v-fade-transition>
      <!-- <router-view></router-view> -->
    </v-content>
    <Setting/>
    <v-footer :fixed="fixed" app inset>
      <span>&copy; 2017</span>
    </v-footer>
  </v-app>
</template>

<script>
import Setting from "@/components/Setting.vue";
import Menus from "@/components/Menus.vue";
import Toolbar from "@/components/Toolbar.vue";
import { init } from "@/permission.js";

export default {
  components: {
    Setting,
    Menus,
    Toolbar
  },
  provide() {
    return {
      reload: this.resufresh
    };
  },
  data() {
    return {
      fixed: false,
      resufreshed: true
    };
  },
  computed: {
    title() {
      return this.$store.state.tenant.Name;
    }
  },
  async created() { 
    try {
      let request = await this.$http.get("/api/account/GetCurrent");
      this.$store.commit("login", request);
      await init();
      this.$eventBus.$emit("init");
    } catch (error) {
      if (this.$route.fullpath != "/login") {
        this.$router.push({
          path: "/login",
          query: {
            redirect: this.$route.fullpath
          }
        });
      }
    }
  },
  methods: {
    resufresh() {
      this.resufreshed = false;
      this.$nextTick(function() {
        this.resufreshed = true;
      });
    }
  }
};
</script>
<style scoped>
.v-toolbar {
  box-shadow: none;
  -webkit-box-shadow: none;
}
body {
  overflow: hidden;
}
.container {
  padding: 5px;
}
</style>

 